import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c44829f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "partners" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "titre-partner" }, "Les partenaires", -1))
const _hoisted_4 = { class: "images" }
const _hoisted_5 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imagesPartners, (image) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "image-partner",
            key: image
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: image.url,
                alt: image.alt
              }, null, 8, _hoisted_5)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}